/**
 * @typedef {'default' | 'new'} UiThemeId
 */

/** @type {UiThemeId} */
export const UI_THEME_DEFAULT = 'default'

/** @type {UiThemeId} */
export const UI_THEME_NEW = 'new'

/** @type {readonly UiThemeId[]} */
export const UI_THEME_IDS = [UI_THEME_DEFAULT, UI_THEME_NEW]

/**
 * Normalize a server-provided theme value to a known UI theme id.
 * Unknown, empty, or missing values fall back to the current (default) UI.
 *
 * @param {unknown} value
 * @returns {UiThemeId}
 */
export function normalizeTheme(value) {
  return value === UI_THEME_NEW ? UI_THEME_NEW : UI_THEME_DEFAULT
}
